<template>
    <rkm-layout-body title="Lista de usuário">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({name: 'web-service-usuario-create'})"
                authorize="store-web-service-usuario"
                color="primary"
            >
                Cadastrar usuário
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/web-service/usuario/List'

export default {
    components: {List},
}
</script>